
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Bhanduptopunecab() {



    const cardData =
    {
        keyword: 'Bhandup to Pune Cab ',
        heading: 'Skyline Cabs: Bhandup to Pune Cab ',
        headingDescription: 'Skyline Cabs provides dependable and affordable Bhandup to Pune Cab services for a smooth and comfortable journey. Whether you are traveling for work, leisure, or a special occasion, our clean, well-maintained vehicles and experienced drivers ensure a safe and timely ride. Enjoy on-time pickups from Bhandup, transparent pricing, and 24/7 customer support. Book your Bhandup to Pune cab with Skyline Cabs and experience hassle-free intercity travel with top-notch service.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Bhandup to Pune Taxi",
      "description": "Skyline Cabs offers reliable and affordable taxi services from Bhandup to Pune. Choose from a variety of vehicles including Innova Crysta, Ertiga, and sedan options for a comfortable journey."
    },
    {
      "name": "Bhandup to Pimpri Chinchwad Taxi",
      "description": "Skyline Cabs provides dependable taxi services from Bhandup to Pimpri Chinchwad. Book your ride online for an easy, smooth trip with multiple vehicle choices."
    },
    {
      "name": "Bhandup to Pune One Way Cab",
      "description": "For a one-way journey from Bhandup to Pune, Skyline Cabs offers affordable and convenient one-way cab services. Book your one-way ride today and enjoy comfort and reliability."
    },
    {
      "name": "Taxi Service Bhandup",
      "description": "Skyline Cabs offers the best taxi services in Bhandup. Whether you need a local ride or an outstation trip, our fleet of vehicles is available to meet all your travel needs."
    },
    {
      "name": "Bhandup to Pune Ertiga Taxi Service",
      "description": "If you prefer an Ertiga for your trip from Bhandup to Pune, Skyline Cabs provides the best service with affordable pricing. Enjoy a smooth and comfortable ride in our well-maintained vehicles."
    },
    {
      "name": "Bhandup to Pune Innova Crysta Taxi Service",
      "description": "Skyline Cabs offers premium Innova Crysta taxis for your journey from Bhandup to Pune. Experience luxury and comfort on your outstation trip with our well-equipped vehicles."
    },
    {
      "name": "Bhandup to Pune Station Taxi Fare",
      "description": "Skyline Cabs offers competitive taxi fares for trips from Bhandup to Pune Station. Book your ride with us for a hassle-free journey with fair and transparent pricing."
    },
    {
      "name": "Bhandup to Koregaon Park Taxi",
      "description": "Book a taxi from Bhandup to Koregaon Park with Skyline Cabs. Our taxis are comfortable, and we offer affordable rates for a smooth and reliable ride."
    },
    {
      "name": "Bhandup to Pune Sedan Taxi Fare",
      "description": "Skyline Cabs offers affordable sedan taxi services from Bhandup to Pune. With transparent pricing and reliable service, your journey is made easy and comfortable."
    },
    {
      "name": "Bhandup to Baner Pune Taxi",
      "description": "Travel from Bhandup to Baner, Pune, with Skyline Cabs. We provide professional taxi services that ensure a comfortable and safe trip, with a range of vehicle options."
    },
    {
      "name": "Mumbai to Pune Cab Fare",
      "description": "Skyline Cabs provides affordable and transparent pricing for taxis from Mumbai to Pune. We offer a wide range of vehicles to cater to your needs, from economy to luxury options."
    },
    {
      "name": "Cab Service in Bhandup",
      "description": "Skyline Cabs offers dependable and affordable taxi services within Bhandup. Whether you need a ride to Pune or a local trip, our fleet of vehicles is available for you."
    },
    {
      "name": "Mumbai to Pune Taxi Fare",
      "description": "Skyline Cabs offers the best pricing for Mumbai to Pune taxi rides. Our pricing is clear and competitive, with no hidden charges for your convenience."
    },
    {
      "name": "Mumbai to Pune Car Rental",
      "description": "Skyline Cabs offers reliable car rental services for your trip from Mumbai to Pune. Choose from a wide selection of vehicles that suit your comfort and budget."
    },
    {
      "name": "Mumbai to Pune Cab Charges",
      "description": "Skyline Cabs offers affordable taxi services from Mumbai to Pune with transparent charges. We ensure you get the best value for your journey, with clear pricing upfront."
    },
    {
      "name": "Mumbai to Pune Cab Fare",
      "description": "Book a taxi from Mumbai to Pune with Skyline Cabs and enjoy the best fare rates. Our pricing includes all fees and tolls, ensuring there are no surprises."
    },
    {
      "name": "Mumbai to Pune Cab Booking",
      "description": "Skyline Cabs makes it easy to book your ride from Mumbai to Pune. Whether you need a one-way or round trip, our user-friendly online booking system ensures a hassle-free process."
    },
    {
      "name": "Cab Service in Mumbai",
      "description": "Skyline Cabs offers reliable taxi services across Mumbai. From local rides to outstation trips, we provide a wide range of vehicles to meet your needs."
    },
    {
      "name": "Cab Booking Mumbai",
      "description": "Skyline Cabs allows you to easily book a taxi in Mumbai through our online booking system. Get a prompt ride with affordable pricing and excellent service."
    },
    {
      "name": "Mumbai Taxi Service",
      "description": "Skyline Cabs provides dependable taxi services all over Mumbai. Whether you need an airport transfer or a local ride, our well-maintained vehicles and professional drivers are ready."
    },
    {
      "name": "Cheapest Cab Service in Mumbai",
      "description": "Skyline Cabs offers the cheapest and most reliable taxi services in Mumbai. Our affordable pricing ensures you get the best value for your journey."
    },
    {
      "name": "Cab Service in Bhandup",
      "description": "Skyline Cabs provides excellent taxi services in Bhandup for local rides, outstation trips, and more. Book your ride online and enjoy a hassle-free journey."
    },
    {
      "name": "Bhandup to Outstation Cab Service",
      "description": "Skyline Cabs offers reliable outstation cab services from Bhandup to various destinations. Choose from our wide range of vehicles for your next outstation trip."
    },
    {
      "name": "Bhandup to Outstation Cab Service Number",
      "description": "For booking an outstation cab from Bhandup, contact Skyline Cabs at [Insert contact number]. Our team is available to assist you with booking and ensure a smooth journey."
    }
  ],
  "tableData": [
    ["Bhandup to Pune Taxi", "Bhandup to Pimpri Chinchwad Taxi"],
    ["Bhandup to Pune One Way Cab", "Taxi Service Bhandup"],
    ["Bhandup to Pune Ertiga Taxi Service", "Bhandup to Pune Innova Crysta Taxi Service"],
    ["Bhandup to Pune Station Taxi Fare", "Bhandup to Koregaon Park Taxi"],
    ["Bhandup to Pune Sedan Taxi Fare", "Bhandup to Baner Pune Taxi"],
    ["Mumbai to Pune Cab Fare", "Cab Service in Bhandup"],
    ["Mumbai to Pune Taxi Fare", "Mumbai to Pune Car Rental"],
    ["Mumbai to Pune Cab Charges", "Mumbai to Pune Cab Fare"],
    ["Mumbai to Pune Cab Booking", "Cab Service in Mumbai"],
    ["Cab Booking Mumbai", "Mumbai Taxi Service"],
    ["Cheapest Cab Service in Mumbai", "Cab Service in Bhandup"],
    ["Bhandup to Outstation Cab Service", "Bhandup to Outstation Cab Service Number"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Bhandup to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable and punctual cab services for your journey from Bhandup to Pune. Whether it’s a business trip, weekend getaway, or family visit, our service ensures a smooth and timely ride every time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our fleet includes a range of well-maintained vehicles, including sedans, SUVs, and luxury cars, designed to make your ride from Bhandup to Pune comfortable and relaxing. With air-conditioning, ample legroom, and a smooth ride, you’ll enjoy your journey from start to finish."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are highly experienced, trained in safe driving practices, and familiar with the best routes for a timely journey from Bhandup to Pune. They ensure your comfort, safety, and punctuality throughout the ride."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Skyline Cabs offers transparent pricing for your Bhandup to Pune journey. You’ll know the cost upfront with no hidden charges, ensuring you get great value for your money while enjoying top-quality service."
    },
    {
        "WhyChooseheading": "24/7 Availability for Convenient Travel",
        "WhyChoosedescription": "No matter what time you need to travel, Skyline Cabs is available 24/7 to take you from Bhandup to Pune. Our flexible scheduling means you can book a ride anytime, whether it’s for an early morning departure or a late-night return."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking your Bhandup to Pune cab is simple with Skyline Cabs. Use our website or mobile app to book your ride in minutes, and receive instant booking confirmation along with the option to track your ride in real-time."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Cabs for Every Trip",
        "WhyChoosedescription": "We prioritize your health and safety. All of our vehicles are cleaned and sanitized after each ride, and our drivers follow strict safety protocols to ensure that you travel in a secure and hygienic environment."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Whether you're traveling alone or with a group, we have a vehicle to fit your needs. From comfortable sedans to spacious SUVs, Skyline Cabs offers a variety of vehicles for a comfortable and customized journey from Bhandup to Pune."
    }
]


























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Bhandup to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Bhandup to Pune is simple and fast. You can book your ride through our website, mobile app, or by calling our customer support team for assistance. Just enter your pickup and drop-off locations, select your vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Bhandup to Pune trip?',
            answer:
                'We offer a range of vehicles to suit your preferences, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury options. Choose the vehicle based on your group size and comfort requirements.',
        },
        {
            id: 3,
            question: 'How long will it take to travel from Bhandup to Pune?',
            answer:
                'The travel time from Bhandup to Pune is approximately 3.5 to 5 hours, depending on traffic conditions. Our experienced drivers take the best routes to ensure timely and smooth travel.',
        },
        {
            id: 4,
            question: 'Are the fares for the Bhandup to Pune cab fixed?',
            answer:
                'Yes, our fares are fixed and include all charges such as tolls, taxes, and driver fees. You’ll be given an upfront fare estimate before confirming your booking to ensure complete transparency.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab service from Bhandup to Pune?',
            answer:
                'Yes, you can easily book a round-trip cab. Provide your return trip details when making the booking, and we’ll arrange your return journey as well, ensuring a smooth experience throughout.',
        },
        {
            id: 6,
            question: 'Can I modify my Bhandup to Pune cab booking?',
            answer:
                'Yes, you can modify or cancel your booking easily through our website, app, or by contacting our customer support team. We offer flexible options for changes and cancellations.',
        },
        {
            id: 7,
            question: 'Are the vehicles for Bhandup to Pune well-maintained?',
            answer:
                'Absolutely! We ensure that all our vehicles are well-maintained, clean, and equipped with necessary amenities like air conditioning, comfortable seating, and more, to ensure a pleasant journey.',
        },
        {
            id: 8,
            question: 'What payment options are available for my Bhandup to Pune cab?',
            answer:
                'We offer multiple payment options, including secure online payments through credit/debit cards, UPI, net banking, and cash. Choose the payment method that’s most convenient for you.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs available for corporate travel from Bhandup to Pune?',
            answer:
                'Yes, Skyline Cabs provides corporate travel services. Whether you need a ride for business meetings or group travel, we can tailor our services to meet your corporate requirements.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Bhandup to Pune trip?',
            answer:
                'Skyline Cabs offers reliable, comfortable, and affordable travel with professional drivers, well-maintained vehicles, and fixed pricing. We ensure a smooth, stress-free journey from Bhandup to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Deepak Jain",
            rating: 5,
            review: "I had an excellent experience traveling from Bhandup to Pune with Skyline Cabs. The driver was punctual, the car was clean, and the journey was smooth. The booking process was easy, and the pricing was fair. Highly recommend!"
        },
        {
            name: "Miss. Anjali Reddy",
            rating: 4,
            review: "I booked a cab for a weekend trip to Pune from Bhandup. The ride was comfortable and the driver was professional. I arrived on time and enjoyed the journey. I will definitely choose Skyline Cabs for my future trips."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bhandup to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/bhandup-to-pune-cab.jpg",
  "description": "Book Bhandup to Pune cabs with Skyline Cabs for a safe, comfortable, and affordable ride. Enjoy 24/7 AC cab service with verified drivers, available for one-way and round-trip bookings.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7147"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/bhandup-to-pune-cabs"
  }
};


      
     
      


    return (
        <div>
<Helmet>
  <title>Bhandup to Pune Cabs | 24x7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Bhandup to Pune cabs with Skyline Cabs for a safe, comfortable, and affordable ride. Enjoy 24/7 AC cab service with verified drivers, available for one-way and round-trip bookings." 
  />
  <meta 
    name="keywords" 
    content="Bhandup to Pune Cabs, Cab from Bhandup to Pune, One-Way Taxi Bhandup to Pune, Round Trip Cab Bhandup to Pune, AC Cab Bhandup to Pune, SUV Taxi Bhandup to Pune, Affordable Taxi Bhandup to Pune, Skyline Cabs Bhandup to Pune, Online Cab Booking Bhandup to Pune, 24/7 Taxi Bhandup to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/46.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bhanduptopunecab;